<template>
    <!-- 浮窗-在线客服 -->
    <drag-component :show="true" :config="config">
        <div @click="onlineConsult">
            <div class="overlay-service"></div>
        </div>
    </drag-component>
</template>

<script>
import Drag from '@/components/common/drag'
import getOnlineService from '@/mixins/onlineService/index'
export default {
    components: {
        'drag-component': Drag
    },
    data() {
        return {
            config: {
                // 初始位置信息
                top: '70%',
                right: '.1rem',
                width: '1rem', // 拖拽元素的宽度 记得带单位
                height: '1rem', // 拖拽元素的高度 记得带单位
                side: true, // 自动靠边
                zIndex: 1
            }
        }
    },
    methods: {
        async onlineConsult() {
            const url = await getOnlineService()
            window.open(url, '_blank')
        }
    }
}
</script>

<style lang="scss" scoped>
.overlay-service {
    margin: 0 auto;
    background-color: #fff;
    z-index: 10;
    width: 1.2rem;
    height: 1.2rem;
    background: url('~@/assets/images/ico/icon-customer.png') no-repeat;
    background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/overlay/customer/index.vue